<div class="flex flex-col gap-2">
  @if (props.label) {
    <label [for]="id" class="font-semibold">
      {{ props.label }}
      <span class="text-red-500" *ngIf="props.required">*</span>
    </label>
  }

  <!-- TODO: Find a way to style this component since the selected day cell is currently a black text on ranalainen's color (bad contrast) -->
  <p-datepicker
    [id]="id"
    [formControl]="dateFormControl"
    [placeholder]="props.placeholder || ''"
    appendTo="body"
    [showIcon]="true"
    [firstDayOfWeek]="firstDayOfWeek"
    [showButtonBar]="true"
    [minDate]="props['minDate']"
    [maxDate]="props['maxDate']"
    [style]="{ width: '100%' }"
    [class.ng-invalid]="isFieldInvalid()"
    [inputStyleClass]="isFieldInvalid() ? 'border border-red-500' : ''"
    (onBlur)="onBlur()"
    [panelStyle]="{ width: '15rem', 'min-width': '275px' }"
    [disabled]="formControl.disabled"
    [ngClass]="{ 'p-disabled': formControl.disabled }"
  ></p-datepicker>

  @if (props.description) {
    <div class="text-sm text-surface-600 dark:text-surface-400">
      {{ props.description }}
    </div>
  }

  @if (isFieldInvalid()) {
    <small class="text-red-500">{{ getErrorMessage() }}</small>
  }
</div>
